import { css } from 'linaria';

const globals = `
  html, body, #root {
    min-height: 100%;
    font-family:"Figtree",Helvetica Neue,Helvetica,Arial,sans-serif;
  }
  .mobileOnly{
      display:none;
  }
  html {
  scroll-behavior: smooth;
}

body > iframe[style*="position: fixed;"] {
  display: none;
}

  @media screen and (max-width: 630px) {
    .desktopOnly{
      display:none;
    }
    .mobileOnly{
      display:block;
    }
  }
  #root {
    display: flex;
    flex-direction: column;
  }
  button {
	  cursor: pointer;
    padding: 0px;
    border: none;
    font: inherit;
	}
  ol, ul, h4, h3, h2, h1 {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  p, dd {
    margin: 0;
    padding: 0;
  }

  /* Safari iPhone color fix */
  a {
    color: black;
  }
    svg {
    color: black;
    }

    button {
    color: black;
    }

  /*--------------------------------------------------*/
  
  input {
    -webkit-appearance: none;
  }
  .ReactModal__Body--open {
    overflow: hidden;
  }
  .ReactModal__Overlay--after-open {
    overflow: scroll;
  }
  .EU-modal{
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    padding: 2rem;
    box-shadow: rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
    border-radius: 5px;
    background:#fff;
  }
  body {

    -webkit-font-smoothing: antialiased;
  }
  /* 
   * apply a natural box layout model to all elements, but allowing components
   * to change */
  html {
    box-sizing: border-box;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }

  .MuiTooltip-popper {
    margin-top: -10px;
  }

  .ReactModalPortal {
    .ReactModal__Overlay {
      z-index: 5;
    }
  }
  .Toastify > div {
    top:0;
  }
  .svg-inline--fa {
    vertical-align:middle;
  }

  /* Global Focus Styles for Accessibility */

  *:focus {
    outline: none!important;
  }
  
  *:focus-visible {
    outline: 2px solid #ff6600;
    outline-offset: 2px;
  }

  /* Remove default focus for elements that will have custom focus */
  button:focus,
  a:focus,
  input:focus,
  select:focus,
  textarea:focus,
  [tabindex]:focus {
    outline: none!important;
  }

  /* Custom focus styles for interactive elements */
  button:focus-visible,
  a:focus-visible,
  [role="button"]:focus-visible,
  [tabindex]:focus-visible {
    box-shadow: 0 0 0 3px #ff6600;
    border-radius: 4px;
    transition: all 0.2s ease;
  }

  /* Focus styles for form elements */
  input:focus-visible,
  select:focus-visible,
  textarea:focus-visible {
    border-color: #ff6600;
    box-shadow: 0 0 0 2px rgba(255, 102, 0, 0.8);
    transition: all 0.2s ease;
  }

  /* Focus styles for product cards and interactive containers */
  .product-card:focus-visible,
  [data-testid="product"]:focus-visible {
    box-shadow: 0 0 0 3px #ff6600;
    transform: translateY(-2px);
    border-radius: 8px;
    transition: all 0.2s ease;
  }

  /* Focus styles for navigation elements */
  .slide-nav:focus-visible,
  .nav-button:focus-visible {
    box-shadow: 0 0 0 3px #ff6600;
    border-radius: 50%;
    background-color: rgba(255, 102, 0, 0.8);
    transition: all 0.2s ease;
  }

  /* High contrast focus for better accessibility */
  @media (prefers-contrast: high) {
    *:focus-visible {
      outline: 3px solid #000;
      outline-offset: 2px;
    }
    
    button:focus-visible,
    a:focus-visible,
    [role="button"]:focus-visible {
      box-shadow: 0 0 0 3px #000;
      background-color: #ffff00;
    }
  }


  .slick-list {
    padding: 2px 0 !important;
  }


  .slick-slide[aria-hidden="true"] a,
.slick-slide[aria-hidden="true"] button,
.slick-slide[aria-hidden="true"] input,
.slick-slide[aria-hidden="true"] select,
.slick-slide[aria-hidden="true"] textarea {
  pointer-events: none !important;
  tabindex: -1 !important;
}


.hide-above-sm {
  @media (min-width: 40rem) {
    display: none;
  }
}

.hide-above-md {
  @media (min-width: 50rem) {
    display: none;
  }
}

.hide-above-lg {
  @media (min-width: 64rem) {
    display: none;
  }
}

.hide-above-xl {
  @media (min-width: 90rem) {
    display: none;
  }
}

.hide-below-sm {
  @media (max-width: 40rem) {
    display: none;
  }
}

.hide-below-md {
  @media (max-width: 50rem) {
    display: none;
  }
}

.hide-below-lg {
  @media (max-width: 64rem) {
    display: none;
  }
}

.hide-below-xl {
  @media (max-width: 90rem) {
    display: none;
  }
}

.image-gallery.fullscreen-modal {
background-color: #ffffffe0;
backdrop-filter: blur(5px);
}

.image-gallery-content.fullscreen {
  background-color: #fffa;

  .image-gallery-slide  {
    background-color: #fffa;
  }
}


`;

css`
  :global() {
    ${globals};
  }
`;

//  breakpoints: {
//       xs: '20rem',
//       sm: '40rem',
//       md: '50rem',
//       lg: '64rem',
//       xl: '90rem'
//     },
